module.exports = __webpack_public_path__ + "assets/img/Type BS (2).37fb5898.jpg";